import {
  fetchClients,
  addRemoteID,
  fetchVehiclesByClient,
  fetchEvents,
  fetchAllDataForm,
  createArenaEvent,
  fetchEventById,
  editArenaEvent,
  fetchEquipments,
  fetchArenaEquipmentVersions,
  fetchEquipmentById,
  createEquipment,
  editEquipment,
  fetchArenaEquipmentVersionById,
  createEquipmentVersion,
  editEquipmentVersion,
  fetchArenaVehicleTypes,
  fetchArenaVehicleTypeById,
  createVehicleType,
  editVehicleType,
  fetchArenaPointTypes,
  fetchArenaPointTypeById,
  createPointType,
  editPointType,
  fetchArenaUserTypes,
  fetchArenaUserTypeById,
  fetchArenaUsers,
  fetchArenaUserById,
  createUser,
  editUser,
  fetchVehicles,
  fetchVehiclesAndAreas,
  fetchVehiclesAndAreasByClient,
  linkVehicleAndArea,
  fetchAreas,
  unlinkVehicleAndAreaGenerateEvents,
  fetchPositionsVWVData,
  removePositionDadoLido,
  fetchTriggeredEvents,
  removeTriggeredEvent,
  fetchArenaUsersByCompany,
  inactivateArenaEvent
} from '@/api/arena'
import { t } from "@/lib/i18n";

const state = {
  clients: [],
  isLoading: false,
  vehiclesByClient: [],
  events: [],
  allDataForm: {},
  eventById: null,
  equipments: [],
  equipmentById: null,
  equipmentVersions: [],
  equipmentVersionById: null,
  vehicleTypes: [],
  vehicleTypeById: null,
  pointTypes: [],
  pointTypeById: null,
  userTypes: [],
  userTypeById: null,
  users: [],
  userById: null,
  vehicles: [],
  vehiclesAndAreasByClient: {
    vehicles: [],
    areas: []
  },
  vehiclesAndAreas: [],
  areas: [],
  positionsVWVData: [],
  triggeredEvents: []
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchClients ({ dispatch, commit }) {
    try {
      dispatch('overlay/show', true, { root: true })

      const clients = await fetchClients()

      commit('setClients', clients)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async addRemoteID ({ dispatch }, payload) {
    try {
      await addRemoteID(payload)

      dispatch(
        'notify/success',
        { message: 'Cadastrado com sucesso!' },
        { root: true }
      )
    } catch (error) {
      if (!error.hasOwnProperty('message')) {
        dispatch('notify/error', error, { root: true })

        return false
      }

      if (error.message === 'remoteIdAlreadyExists') {
        dispatch('notify/error', { message: `Tags "${error.data}" já cadastrada(s)! ` }, { root: true })
      }
    }
  },

  async fetchVehiclesByClient({ dispatch, commit }, payload) {
    try {
      dispatch('overlay/show', true, { root: true })

      const vehicles = await fetchVehiclesByClient(payload)

      commit('setVehiclesByClient', vehicles)
    } catch (error) {
      console.log('[ERROR-FETCH-VEHICLES-BY-CLIENT] =>', error)
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async fetchEvents({ dispatch, commit }, payload) {
    try {
      dispatch('overlay/show', true, { root: true })

      const events = await fetchEvents(payload)

      commit('setEvents', events)
    } catch (error) {
      console.log('[ERROR-FETCH-EVENTS] =>', error)
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async fetchAllDataForm({ dispatch, commit }, payload) {
    try {
      dispatch('overlay/show', true, { root: true })

      const data = await fetchAllDataForm(payload)

      commit('setAllDataForm', data)
    } catch (error) {
      console.log('[ERROR-FETCH-ALL-DATA-FORM] =>', error)
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async createArenaEvent({ dispatch }, payload) {
    try {
      dispatch('overlay/show', true, { root: true })

      await createArenaEvent(payload)

      return true
    } catch (error) {
      console.log('[ERROR-CREATE-ARENA-EVENT] =>', error)

      return false
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async editArenaEvent({ dispatch }, payload) {
    try {
      dispatch('overlay/show', true, { root: true })

      await editArenaEvent(payload.id, payload.data)

      return true
    } catch (error) {
      console.log('[ERROR-EDIT-ARENA-EVENT] =>', error)

      return false
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async fetchEventById ({ dispatch, commit }, id) {
    try {
      dispatch('overlay/show', true, { root: true })

      const event = await fetchEventById(id)

      commit('setEventById', event)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  clearEvents({ commit }) {
    commit('setEvents', [])
  },

  async fetchEquipments ({ dispatch, commit }, params) {
    try {
      dispatch('overlay/show', true, { root: true })

      const equipments = await fetchEquipments(params)

      commit('setEquipments', equipments)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async fetchEquipmentById ({ dispatch, commit }, id) {
    try {
      dispatch('overlay/show', true, { root: true })

      const event = await fetchEquipmentById(id)

      commit('setEquipmentById', event)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async createEquipment({ dispatch, commit }, data) {
    commit("setLoading", true);
    try {
      await createEquipment(data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async editEquipment({ dispatch, commit }, { id, data }) {
    commit("setLoading", true);
    try {
      await editEquipment(id, data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async fetchArenaEquipmentVersions ({ dispatch, commit }) {
    try {
      dispatch('overlay/show', true, { root: true })

      const equipmentVersions = await fetchArenaEquipmentVersions()

      commit('setEquipmentVersions', equipmentVersions)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async fetchArenaEquipmentVersionById ({ dispatch, commit }, id) {
    try {
      dispatch('overlay/show', true, { root: true })

      const equipmentVersion = await fetchArenaEquipmentVersionById(id)

      commit('setEquipmentVersionById', equipmentVersion)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async createEquipmentVersion({ dispatch, commit }, data) {
    commit("setLoading", true);
    try {
      await createEquipmentVersion(data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async editEquipmentVersion({ dispatch, commit }, { id, data }) {
    commit("setLoading", true);
    try {
      await editEquipmentVersion(id, data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async fetchArenaVehicleTypes ({ dispatch, commit }) {
    try {
      dispatch('overlay/show', true, { root: true })

      const vehicleTypes = await fetchArenaVehicleTypes()

      commit('setVehicleTypes', vehicleTypes)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async fetchArenaVehicleTypeById ({ dispatch, commit }, id) {
    try {
      dispatch('overlay/show', true, { root: true })

      const vehicleType = await fetchArenaVehicleTypeById(id)

      commit('setVehicleTypeById', vehicleType)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async createVehicleType({ dispatch, commit }, data) {
    commit("setLoading", true);
    try {
      await createVehicleType(data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async editVehicleType({ dispatch, commit }, { id, data }) {
    commit("setLoading", true);
    try {
      await editVehicleType(id, data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async fetchArenaPointTypes ({ dispatch, commit }) {
    try {
      dispatch('overlay/show', true, { root: true })

      const pointTypes = await fetchArenaPointTypes()

      commit('setPointTypes', pointTypes)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async fetchArenaPointTypeById ({ dispatch, commit }, id) {
    try {
      dispatch('overlay/show', true, { root: true })

      const pointType = await fetchArenaPointTypeById(id)

      commit('setPointTypeById', pointType)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async createPointType({ dispatch, commit }, data) {
    commit("setLoading", true);
    try {
      await createPointType(data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async editPointType({ dispatch, commit }, { id, data }) {
    commit("setLoading", true);
    try {
      await editPointType(id, data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async fetchArenaUserTypes ({ dispatch, commit }) {
    try {
      dispatch('overlay/show', true, { root: true })

      const userTypes = await fetchArenaUserTypes()

      commit('setUserTypes', userTypes)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async fetchArenaUserTypeById ({ dispatch, commit }, id) {
    try {
      dispatch('overlay/show', true, { root: true })

      const user = await fetchArenaUserTypeById(id)

      commit('setUserTypeById', user)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async createUserType({ dispatch, commit }, data) {
    commit("setLoading", true);
    try {
      await createUserType(data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async editUserType({ dispatch, commit }, { id, data }) {
    commit("setLoading", true);
    try {
      await editUserType(id, data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async fetchArenaUsers ({ dispatch, commit }, payload) {
    try {
      dispatch('overlay/show', true, { root: true })

      const users = await fetchArenaUsers(payload)

      commit('setUsers', users)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async fetchArenaUsersByCompany ({ dispatch, commit }, company) {
    try {
      dispatch('overlay/show', true, { root: true })

      const user = await fetchArenaUsersByCompany(company)

      commit('setUsers', user)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async fetchArenaUserById ({ dispatch, commit }, id) {
    try {
      dispatch('overlay/show', true, { root: true })

      const user = await fetchArenaUserById(id)

      commit('setUserById', user)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async createUser({ dispatch, commit }, data) {
    commit("setLoading", true);
    try {
      await createUser(data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      if (message === 'alreadyExists') {
        message = t('login_already_registered');
      }

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async editUser({ dispatch, commit }, { id, data }) {
    commit("setLoading", true);
    try {
      await editUser(id, data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      if (message === 'alreadyExists') {
        message = t('login_already_registered');
      }

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async fetchVehicles({ dispatch, commit }, payload) {
    try {
      dispatch('overlay/show', true, { root: true })

      const rows = await fetchVehicles(payload)

      commit('setVehicles', rows)
    } catch (error) {
      console.log('[ERROR-FETCH-VEHICLES] =>', error)
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async fetchVehiclesAndAreas({ dispatch, commit }, payload) {
    try {
      dispatch('overlay/show', true, { root: true })

      const rows = await fetchVehiclesAndAreas(payload)

      commit('setVehiclesAndAreas', rows)
    } catch (error) {
      console.log('[ERROR-FETCH-VEHICLES-AND-AREAS] =>', error)
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async fetchVehiclesAndAreasByClient({ dispatch, commit }, payload) {
    try {
      dispatch('overlay/show', true, { root: true })

      const vehicles = await fetchVehiclesAndAreasByClient(payload)

      commit('setVehiclesAndAreasByClient', vehicles)
    } catch (error) {
      console.log('[ERROR-FETCH-VEHICLES-AND-AREAS-BY-CLIENT] =>', error)
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async linkVehicleAndArea({ dispatch, commit }, data) {
    commit("setLoading", true);
    try {
      await linkVehicleAndArea(data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );

      return false;
    } finally {
      commit("setLoading", false);
    }
  },

  async fetchAreas({ dispatch, commit }, payload) {
    try {
      dispatch('overlay/show', true, { root: true })

      const areas = await fetchAreas(payload)

      commit('setAreas', areas)
    } catch (error) {
      console.log('[ERROR-FETCH-AREAS] =>', error)
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async unlinkVehicleAndAreaGenerateEvents({ dispatch, commit }, data) {
    commit("setLoading", true);

    try {
      await unlinkVehicleAndAreaGenerateEvents(data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );

      return false;
    } finally {
      commit("setLoading", false);
    }
  },

  async fetchPositionsVWVData({ dispatch, commit }, payload) {
    try {
      dispatch('overlay/show', true, { root: true })

      const positions = await fetchPositionsVWVData(payload)

      commit('setPositionsVWVData', positions)
    } catch (error) {
      console.log('[ERROR-FETCH-POSITIONS-VW-VDATA] =>', error)
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async removePositionDadoLido({ dispatch, commit }, data) {
    commit("setLoading", true);

    try {
      await removePositionDadoLido(data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );

      return false;
    } finally {
      commit("setLoading", false);
    }
  },

  async fetchTriggeredEvents({ dispatch, commit }, payload) {
    try {
      dispatch('overlay/show', true, { root: true })

      const events = await fetchTriggeredEvents(payload)

      commit('setTriggeredEvents', events)
    } catch (error) {
      console.log('[ERROR-FETCH-TRIGGERED-EVENTS] =>', error)
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async removeTriggeredEvent({ dispatch, commit }, data) {
    commit("setLoading", true);

    try {
      await removeTriggeredEvent(data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );

      return false;
    } finally {
      commit("setLoading", false);
    }
  },

  async inactivateArenaEvent({ dispatch, commit }, payload) {
    try {
      commit('setLoading', true)

      await inactivateArenaEvent(payload)

      dispatch(
        'toast/showToast',
        {
          message: 'Evento desativado!',
          type: 'success',
        },
        { root: true }
      );

      return true
    } catch (error) {
      console.log('[ERROR-INACTIVATE-ARENA-EVENT] =>', error)

      dispatch(
        'toast/showToast',
        {
          message: 'Erro ao desativar evento!',
          type: 'error',
        },
        { root: true }
      );

      return false
    } finally {
      commit('setLoading', false)
    }
  },

  async createUserWebService ({ dispatch }, company) {
    try {
      dispatch('overlay/show', true, { root: true })

      await fetch('https://api.frotix.com.br/users/webservice/', {
        method: 'POST',
        body: JSON.stringify({ company }),
      });

      dispatch(
        'toast/showToast',
        {
          message: 'Usuário criado com sucesso!',
          type: 'success'
        },
        { root: true }
      );
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },
}

const mutations = {
  cleanState (state) {
    state.clients = []
    state.isLoading = false
    state.vehiclesByClient = []
    state.events = []
    state.allDataForm = {}
    state.equipments = []
    state.equipmentVersions = []
    state.equipmentById = null
    state.vehicles = []
    state.vehiclesAndAreas = []
    state.vehiclesAndAreasByClient = {
      vehicles: [],
      areas: []
    },
    state.areas = []
    state.positionsVWVData = []
    state.triggeredEvents = []
  },

  setClients (state, clients) {
    state.clients = clients
  },

  setVehiclesByClient (state, vehiclesByClient) {
    state.vehiclesByClient = vehiclesByClient
  },

  setEvents (state, events) {
    state.events = events
  },

  setAllDataForm (state, data) {
    state.allDataForm = data
  },

  setEventById (state, event) {
    state.eventById = event
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },

  setEquipments (state, equipments) {
    state.equipments = equipments
  },

  setEquipmentById (state, equipment) {
    state.equipmentById = {
      ...equipment,
      serie: equipment.id,
      version: equipment.VER_ID,
      client: equipment.CLI_ID,
      ddd: equipment.EQP_DDD || '',
      phone: equipment.EQP_TEL || '',
      operator: equipment.EQP_OPC || '',
      pin: equipment.EQP_PIN || '',
      puk: equipment.EQP_PUK || '',
      eqp_srt: equipment.EQP_SRT || '',
    }
  },

  setEquipmentVersions (state, equipmentVersions) {
    state.equipmentVersions = equipmentVersions
  },

  setEquipmentVersionById (state, equipmentVersion) {
    state.equipmentVersionById = equipmentVersion
  },

  setVehicleTypes (state, vehicleTypes) {
    state.vehicleTypes = vehicleTypes
  },

  setVehicleTypeById (state, vehicleType) {
    state.vehicleTypeById = vehicleType
  },

  setPointTypes (state, pointTypes) {
    state.pointTypes = pointTypes
  },

  setPointTypeById (state, pointType) {
    state.pointTypeById = pointType
  },

  setUserTypes (state, userTypes) {
    state.userTypes = userTypes
  },

  setUserTypeById (state, userType) {
    state.userTypeById = userType
  },

  setUsers (state, users) {
    state.users = users
  },

  setUserById (state, user) {
    state.userById = user
  },

  setVehicles (state, vehicles) {
    state.vehicles = vehicles
  },

  setVehiclesAndAreas (state, vehiclesAndAreas) {
    state.vehiclesAndAreas = vehiclesAndAreas
  },

  setVehiclesAndAreasByClient (state, vehiclesAndAreasByClient) {
    state.vehiclesAndAreasByClient = {
      vehicles: vehiclesAndAreasByClient.vehicles || [],
      areas: vehiclesAndAreasByClient.areas || []
    }
  },

  cleanVehicleAndAreaByClient (state) {
    state.vehiclesAndAreasByClient = {
      vehicles: [],
      areas: []
    }
  },

  setAreas(state, areas) {
    state.areas = areas
  },

  setPositionsVWVData(state, positions) {
    state.positionsVWVData = positions
  },

  setTriggeredEvents(state, triggeredEvents) {
    state.triggeredEvents = triggeredEvents
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
